<template>
  <g>
    <path
      d="M19.5 21.0002C20.3284 21.0002 21 20.3287 21 19.5002C21 18.6718 20.3284 18.0002 19.5 18.0002C18.6716 18.0002 18 18.6718 18 19.5002C18 20.3287 18.6716 21.0002 19.5 21.0002Z"
    />
    <path
      d="M11 18.0303V8.98029L15.22 6.83029C15.95 6.46029 15.95 5.40029 15.21 5.04029L10.45 2.71029C9.78 2.38029 9 2.86029 9 3.60029V19.0003C9 19.5503 8.55 20.0003 8 20.0003C7.45 20.0003 7 19.5503 7 19.0003V18.2703C5.21 18.6203 4 19.2603 4 20.0003C4 21.1003 6.69 22.0003 10 22.0003C13.31 22.0003 16 21.1003 16 20.0003C16 19.0103 13.84 18.1903 11 18.0303Z"
    />
  </g>
</template>
